export const isExternalLink = (str: string) =>
  str.startsWith('http') || str.startsWith('mailto:');

export const SOURCES_WITH_FIRM_OFFERS = ['Even', 'Auto Approve'];
